// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PatientPage-Messages-__converse__container--2sl3C","wrappedComponent":"src-components-PatientPage-Messages-__converse__wrappedComponent--TrZoJ","email":"src-components-PatientPage-Messages-__converse__email--1GrFq","editor":"src-components-PatientPage-Messages-__converse__editor--3yEGc","messages":"src-components-PatientPage-Messages-__converse__messages--237Ri","noneFound":"src-components-PatientPage-Messages-__converse__noneFound--3otB2","newConvoButton":"src-components-PatientPage-Messages-__converse__newConvoButton--2enAN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientPage/Messages/converse.css
// module id = 1984
// module chunks = 0